<template>
  <PageLayout>
    <div class="text-right pb-14">
      <span class="navy--text">Máte potíže?</span>
      <router-link to="/" class="link link-underline navy--text ml-2"
        >Pomoc</router-link
      >
    </div>

    <ui-billing-plans v-model="plan" />

    <template #footer>
      <v-row>
        <v-col>
          <v-btn color="white" class="c-btn" @click="goBack" min-width="186">
            Zpět
          </v-btn>
        </v-col>

        <v-col class="text-right">
          <v-btn
            color="primary"
            class="c-btn"
            min-width="186"
            :disabled="plan === null"
            @click="createOrder"
          >
            Přejít k platbě
            <v-icon right>mdi-arrow-right</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </template>
  </PageLayout>
</template>

<script>
import PageLayout from "@/components/page/onboard/PageLayout.vue"
import OrderAPI from "@/api/orders"
import store from "@/store"

export default {
  name: "ChooseAccount",
  components: {
    PageLayout,
  },
  beforeRouteEnter(to, from, next) {
    store.dispatch("auth/getSubscription").then(() => {
      if (store.state.auth.subscription !== null) {
        next("/dashboard")
      } else {
        next()
      }
    })
  },
  data() {
    return {
      plan: null,
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    createOrder() {
      OrderAPI.createOrder(this.plan).then(response => {
        window.location.href = response.redirectUrl
      })
    },
  },
}
</script>
